// Seletor de montadora/modelo com DOIS grupos: o que a loja tem peça e o
// universo FIPE. Morava dentro de BuscaGuiada.tsx até 14/09/2026, quando o
// campo de carro da VENDA (073) passou a precisar do mesmo controle.
//
// MOVIDO, não copiado: é ele que garante que "VW", "Volks" e "Volkswagen" não
// virem três montadoras. Duas cópias divergem, e a divergência aqui reaparece
// como três carros diferentes no relatório do mês — exatamente o problema que
// a 073 existe para acabar.

/**
 * Seletor com dois grupos: primeiro o que a LOJA tem peça, depois o universo
 * FIPE. Os rótulos dos grupos são o contrato honesto da tela — o vendedor
 * sempre acha o carro, e vê de qual lado ele veio antes de prometer nada.
 *
 * O que já aparece no primeiro grupo é removido do segundo: repetir a mesma
 * montadora em dois lugares faz parecer que são coisas diferentes.
 */
export default function SeletorEmDoisGrupos({
  id, valor, aoTrocar, comPeca, doCatalogo, vazio, desabilitado = false,
}: {
  id: string; valor: string; aoTrocar: (v: string) => void;
  comPeca: string[]; doCatalogo: string[]; vazio: string; desabilitado?: boolean;
}) {
  const jaListado = new Set(comPeca.map((m) => m.toLowerCase()));
  const resto = doCatalogo.filter((m) => !jaListado.has(m.toLowerCase()));

  return (
    <select
      id={id}
      className="campo"
      value={valor}
      disabled={desabilitado}
      onChange={(e) => aoTrocar(e.target.value)}
    >
      <option value="">{vazio}</option>
      {comPeca.length > 0 && (
        <optgroup label="Com peças na loja">
          {comPeca.map((m) => <option key={m} value={m}>{m}</option>)}
        </optgroup>
      )}
      {resto.length > 0 && (
        <optgroup label={comPeca.length > 0 ? 'Outras (catálogo FIPE)' : 'Catálogo FIPE'}>
          {resto.map((m) => <option key={m} value={m}>{m}</option>)}
        </optgroup>
      )}
      {/* Valor que veio da placa e não está em nenhuma das listas continua
          selecionável — senão a busca por placa perderia o carro que acabou
          de identificar. */}
      {valor && !jaListado.has(valor.toLowerCase())
        && !resto.some((m) => m.toLowerCase() === valor.toLowerCase()) && (
        <option value={valor}>{valor}</option>
      )}
    </select>
  );
}
